export var RankEnum;
(function (RankEnum) {
    RankEnum["Iron"] = "iron";
    RankEnum["Bronze"] = "bronze";
    RankEnum["Silver"] = "silver";
    RankEnum["Gold"] = "gold";
    RankEnum["Platinum"] = "platinum";
    RankEnum["Diamond"] = "diamond";
    RankEnum["Titanium"] = "titanium";
    RankEnum["Obsidian"] = "obsidian";
    RankEnum["Emerald"] = "emerald";
    RankEnum["Vibranium"] = "vibranium";
    RankEnum["Vip"] = "vip";
})(RankEnum || (RankEnum = {}));
export const Ranks = Object.values(RankEnum);
